import { render } from "./EnTerm.vue?vue&type=template&id=7404ebb5&scoped=true"
import script from "./EnTerm.vue?vue&type=script&scoped=true&lang=js"
export * from "./EnTerm.vue?vue&type=script&scoped=true&lang=js"

import "../../../../assets/css/agreement.css?vue&type=style&index=0&id=7404ebb5&scoped=true&lang=css"
import "./EnTerm.vue?vue&type=style&index=1&id=7404ebb5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7404ebb5"

export default script